'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var PooledSeasonalityIndexAnalysisChartController = function PooledSeasonalityIndexAnalysisChartController($scope, $rootScope, pooledReviewCalendarService, indexAnalysisChartDataService, seasonalityReviewConstants, seasonalityConstants) {
  $scope.maxSelectableRtp = 5;
  $scope.indexChartData = [];
  $scope.initializing = true;
  $scope.filters = {};
  $scope.indexHeaders = _.range(1, 53, 1); //WoY Index header 1 - 52

  $scope.init = function () {
    pooledReviewCalendarService.getSimpleHepConfig(seasonalityReviewConstants.DEFAULT_RTPS) //Fetch configured RTPs
    .then(function (hepSimple) {
      var rtps = $scope.indexRtps;
      if (!_.isEmpty(hepSimple)) {
        var filteredRtps = _.filter(hepSimple.split(','), function (rtp) {
          return _.includes(rtps, rtp);
        });
        if (!_.isEmpty(filteredRtps)) {
          rtps = filteredRtps;
        }
      }
      rtps = rtps.slice(0, 5);
      $scope.filters = {
        selectedCabin: $scope.indexCabins[0],
        selectedClassGroup: $scope.indexClassGroups[0],
        selectedRtp: rtps,
        selectedDow: $scope.indexDowGroups[0],
        significantPOS: $scope.screenState.spos
      };
      $scope.getChartData($scope.filters); //Then load Index analysis chart

      //Then set up watch group on filters
      $scope.$watchGroup(['filters.selectedClassGroup', 'filters.selectedRtp', 'filters.selectedDow', 'screenState.flowType'], function (newValue, oldValue) {
        if (!_.isEqual(newValue, oldValue)) {
          redrawChart();
        }
      });
    });
  };
  $scope.getChartData = function (filterData) {
    indexAnalysisChartDataService.getIndexChartData($scope.screenState.flowType, $scope.displayedCalendar, filterData).then(function (response) {
      return indexAnalysisChartDataService.transformData(response, $scope.filters.selectedRtp);
    }).then(function (data) {
      $scope.initializing = false;
      $scope.indexChartData = data;
    })["catch"](function (e) {
      toastr.error('Error occured while retrieving Profile data', e);
    });
  };
  $scope.getClassGroupsPerCabin = function (cabin) {
    var filteredMapping = _.get($scope.cabinClassGroups, cabin);
    return _.chain(filteredMapping).map(function (mapping) {
      return mapping.classGroup;
    }).uniq().value();
  };
  $scope.handleCabinChangeEvent = function () {
    $scope.indexClassGroups = $scope.getClassGroupsPerCabin($scope.filters.selectedCabin);
    $scope.filters.selectedClassGroup = $scope.indexClassGroups[0];
  };
  $scope.publishCalendar = function () {
    $scope.$emit('pooled-seasonality:publish-profile-request');
  };
  $scope.isPublishButtonDisabled = function () {
    var status = $scope.displayedCalendar.calendarEntryStatus;
    return status === seasonalityConstants.CALENDAR_STATUSES.RUNNING || status === seasonalityConstants.CALENDAR_STATUSES.PUBLISHED || status === seasonalityConstants.CALENDAR_STATUSES.INACTIVE;
  };
  function redrawChart() {
    $scope.initializing = true;
    var filterData = $scope.filters;
    $scope.getChartData(filterData);
  }
};
PooledSeasonalityIndexAnalysisChartController.$inject = ['$scope', '$rootScope', 'PooledReviewCalendarService', 'IndexAnalysisChartDataService', 'PooledSeasonalityReviewConstants', 'SeasonalityConstants'];
module.exports = PooledSeasonalityIndexAnalysisChartController;